/**
 * RESSONÂNCIA CURATIVA — E-BOOK PRODUCT PAGE
 * product-ebook.js
 * Módulos: Countdown | FAQ | Viewer Counter | Social Proof Pop | CTA Animations
 */

(function () {
  'use strict';

  /* ══════════════════════════════════════════════
     1. COUNTDOWN TIMER
  ══════════════════════════════════════════════ */
  function initCountdown() {
    var hoursEl   = document.getElementById('eb-hours');
    var minutesEl = document.getElementById('eb-minutes');
    var secondsEl = document.getElementById('eb-seconds');
    if (!hoursEl || !minutesEl || !secondsEl) return;

    var DURATION = 47 * 60; // 47 minutos em segundos
    var KEY = 'eb_countdown_end';
    var now = Math.floor(Date.now() / 1000);
    var endTime = parseInt(sessionStorage.getItem(KEY), 10);

    if (!endTime || endTime <= now) {
      endTime = now + DURATION;
      sessionStorage.setItem(KEY, endTime);
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var remaining = endTime - Math.floor(Date.now() / 1000);
      if (remaining <= 0) {
        endTime = Math.floor(Date.now() / 1000) + DURATION;
        sessionStorage.setItem(KEY, endTime);
        remaining = DURATION;
      }
      var hours   = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;

      hoursEl.textContent   = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);

      if (remaining < 300) {
        var cd = document.getElementById('eb-countdown');
        if (cd) cd.style.animation = 'eb-pulse 1s ease-in-out infinite';
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ══════════════════════════════════════════════
     2. FAQ ACCORDION
  ══════════════════════════════════════════════ */
  function initFAQ() {
    var faqList = document.getElementById('eb-faq-list');
    if (!faqList) return;

    var buttons = faqList.querySelectorAll('.eb-faq-item__question');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen  = btn.getAttribute('aria-expanded') === 'true';
        var answer  = btn.nextElementSibling;

        buttons.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var a = b.nextElementSibling;
          if (a) a.classList.remove('is-open');
        });

        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          if (answer) answer.classList.add('is-open');
        }
      });
    });
  }

  /* ══════════════════════════════════════════════
     3. VIEWER COUNTER
  ══════════════════════════════════════════════ */
  function initViewerCount() {
    var el = document.getElementById('eb-viewer-count');
    if (!el) return;

    var base = 230 + Math.floor(Math.random() * 40);
    el.textContent = base;

    setInterval(function () {
      var delta = Math.floor(Math.random() * 11) - 5;
      base = Math.max(190, Math.min(320, base + delta));
      el.textContent = base;
    }, 7000);
  }

  /* ══════════════════════════════════════════════
     4. SCROLL REVEAL
  ══════════════════════════════════════════════ */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    var revealEls = document.querySelectorAll(
      '.eb-chapter-card, .eb-testimonial, .eb-for-who__col, .eb-guarantee__card'
    );

    revealEls.forEach(function (el, i) {
      el.style.opacity  = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.55s ease ' + (i % 3) * 0.1 + 's, transform 0.55s ease ' + (i % 3) * 0.1 + 's';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity  = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    revealEls.forEach(function(el) {
      observer.observe(el);
    });
  }

  // Inicializa tudo perfeitamente ao carregar a página
  document.addEventListener('DOMContentLoaded', function() {
    initCountdown();
    initFAQ();
    initViewerCount();
    initScrollReveal();
  });

})();